import { CollectionCardProps } from 'app/components/collection/CollectionCard'
import {
  CollectionType,
  createCollectionFragment,
} from 'app/queries/collections/collection-fragment'
import { gql } from 'graphql-request'

import { defaultsQuery } from '../globals/defaults'
import { contentFragments } from 'app/queries/content/all-content-list'
import {
  mapContentPagination,
  PaginationWithFeatured,
} from 'app/queries/content/content-list'

export interface CollectionProps extends CollectionCardProps {
  id: string
  subtitle?: string
  heroImage?: string
}

export interface PaginatedCollection extends PaginationWithFeatured {
  collection: CollectionProps
}

export const typeToName = (type: CollectionType) => {
  if (type === 'MemberTier') {
    return `contentTier`
  }

  return type.toLowerCase()
}

export const createCollectionQuery = (type: CollectionType = 'Collection') => {
  const collectionQuery = gql`
    ${createCollectionFragment(type, true)}
    ${contentFragments}
    query getCollection($collection: String, $contentTier: String, $tag: String, $page: Int, $limit: Int, $sort: String) {
      contentList (
        collection: $collection
        contentTier: $contentTier
        tag: $tag

        page: $page
        limit: $limit
        sort: $sort
      ) {
        totalDocs
        page
        docs {
          ...content
        }
        featured {
          ...content
        }
        ${typeToName(type)} {
          ...collection
        }
      }
      ${defaultsQuery}
    }
  `
  const mapToPage = (data: any): PaginatedCollection => {
    const collection = data.contentList[typeToName(type)]
    const defaults = data.Defaults
    const props: CollectionProps = {
      id: collection.id,
      image:
        collection.thumbnail?.sizes?.square?.url ||
        defaults.thumbnail.sizes.thumbnail.url,
      heroImage: collection.heroImage?.sizes?.thumbnail2x?.url || '',
      title: collection.name,
      href: `/${type}/${collection.slug}`,
      itemCount: collection.itemCount || 0,
      subtitle: collection.subtitle || '',
    }

    return {
      ...mapContentPagination(data.contentList, data),
      collection: props,
    }
  }

  return {
    query: collectionQuery,
    mapToPage,
  }
}
